const REMEMBER_ME_KEY = 'REMEMBER_ME';
const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN_KEY';
const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN_KEY';
const TOKEN_EXPIRES_AT_KEY = 'TOKEN_EXPIRES_AT_KEY';

/**
 * Получить токен по ключу
 * @param tokenName
 */
function getToken(tokenName: string) {
  const isRememberedMe = localStorage.getItem(REMEMBER_ME_KEY) === 'true';
  return isRememberedMe ? localStorage.getItem(tokenName) : sessionStorage.getItem(tokenName);
}

/**
 * Установить признак "Запомнить меня"
 * @param remember
 */
const setRememberMe = (remember: boolean): void => {
  window.localStorage.setItem(REMEMBER_ME_KEY, remember ? 'true' : 'false');
};

/**
 * Сохранить токены авторизации
 * @param accessToken
 * @param refreshToken
 * @param expiresIn - время жизни токена в секундах (опционально)
 */
const setTokens = (accessToken: string, refreshToken: string, expiresIn?: number): void => {
  const isRememberedMe = window.localStorage.getItem(REMEMBER_ME_KEY) === 'true';

  if (isRememberedMe) {
    window.localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    window.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);

    if (expiresIn) {
      const expiresAt = Date.now() + expiresIn * 1000;
      window.localStorage.setItem(TOKEN_EXPIRES_AT_KEY, expiresAt.toString());
    }
  } else {
    window.sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    window.sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);

    if (expiresIn) {
      const expiresAt = Date.now() + expiresIn * 1000;
      window.sessionStorage.setItem(TOKEN_EXPIRES_AT_KEY, expiresAt.toString());
    }
  }
};

/**
 * Получить access токен авторизации
 */
const getAccessToken = () => getToken(ACCESS_TOKEN_KEY);

/**
 * Получить refresh токен авторизации
 */
const getRefreshToken = () => getToken(REFRESH_TOKEN_KEY);

/**
 * Получить время истечения токена (timestamp)
 */
const getTokenExpiresAt = (): number | null => {
  const expiresAt = getToken(TOKEN_EXPIRES_AT_KEY);
  return expiresAt ? parseInt(expiresAt, 10) : null;
};

/**
 * Получить время до истечения токена в миллисекундах
 */
const getTimeUntilTokenExpiration = (): number | null => {
  const expiresAt = getTokenExpiresAt();
  if (!expiresAt) return null;

  return Math.max(0, expiresAt - Date.now());
};

const deleteTokens = () => {
  window.sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  window.sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  window.sessionStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
  window.localStorage.removeItem(ACCESS_TOKEN_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN_KEY);
  window.localStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
  window.localStorage.removeItem(REMEMBER_ME_KEY);
};

export {
  setTokens,
  setRememberMe,
  deleteTokens,
  getAccessToken,
  getRefreshToken,
  getTokenExpiresAt,
  getTimeUntilTokenExpiration,
};
